export default "__VITE_ASSET__DEHMA83V__"